export async function setPlayoutDelay(
  remoteFeeds: Record<string, any>,
  suids: Record<string, string>,
  sdkServer: string,
  sdkServerUserInfo: any
): Promise<void> {
  for (const id of Object.keys(remoteFeeds)) {
    const suid = suids[id];
    if (!suid) return;

    try {
      const form = new URLSearchParams();
      form.append("credential", sdkServerUserInfo.credential);

      const res = await fetch(
        `${sdkServer}/transmitters/${suid}/current_status`,
        {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: form.toString(),
        }
      );

      if (!res.ok) {
        if (res.status !== 404) {
          console.log("***DEBUG** XMLHttpRequest : " + res.status);
        }
        continue;
      }

      const response = await res.json();
      const delayInfo = response.data?.target_delay;

      if (!delayInfo || delayInfo.delay_ms == null) {
        console.warn("delayInfo 不正な形式:", delayInfo, "response:", response);
        continue;
      }

      const config = remoteFeeds[id]?.webrtcStuff;
      if (!config?.pc) {
        console.error("Invalid PeerConnection");
      }

      const receivers = config.pc.getReceivers();
      const delay = delayInfo.delay_ms / 1000;

      receivers.forEach((receiver: RTCRtpReceiver) => {
        try {
          (receiver as any).playoutDelayHint = delay;
          console.log(`SUID:${suid}  playoutDelayHint: ${delay}`);
        } catch (e) {
          console.warn("playoutDelayHint 設定失敗", e);
        }
      });
    } catch (err: any) {
      console.log("***DEBUG** error : " + (err?.message ?? err));
    }
  }
}
